import { UpdatePaymentForm } from "@forwardflow/forms/UpdatePaymentForm";
import { ENV } from "@forwardflow/helpers/configs/envConfig";
import { useUpdatePaymentModalStore } from "@forwardflow/store/modal/updatePaymentModal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Modal } from "antd";

export const UpdatePaymentModal = () => {
  const { isUpdatePaymentModalOpen, closeUpdatePaymentModal } =
    useUpdatePaymentModalStore();
  const stripePromise = loadStripe(ENV.STRIPE_ID);
  return (
    <Modal
      className="ff-modal"
      title="Update Payment Information"
      open={isUpdatePaymentModalOpen}
      onCancel={closeUpdatePaymentModal}
      footer={null}
    >
      <p className="mt-5 mb-14">
        Billing will be done on the updated card from next month onwards
      </p>

      <Elements stripe={stripePromise}>
        <UpdatePaymentForm packageId="a622f2ca-69c4-4be6-a7bb-37521f74e903" />
      </Elements>

      <button
        onClick={closeUpdatePaymentModal}
        className="w-full h-12 mt-2 font-semibold transition-all border rounded border-white/20 hover:bg-white/10"
      >
        Cancel
      </button>
    </Modal>
  );
};
